<div class="py-5 vh-100 d-flex justify-content-center align-items-center">
  <div class="container">
    <img
      src="assets/images/svg/forbidden.svg"
      class="img-fluid d-block mx-auto col-12 col-md-4"
      alt="403"
    />
    <h2
      class="text-align-center fw-600 text-primary"
      translate="do_not_have_access"
    ></h2>
    <p class="text-align-center fs-6 text-info"></p>

    <button
      type="button"
      [routerLink]="['/']"
      translate="return_home"
      class="btn btn-primary text-white d-block mx-auto mt-5 rounded-8 px-4 py-2 text-capitalize"
    ></button>
  </div>
</div>
